import { render } from "./PlumbingSetup.vue?vue&type=template&id=cfa03dee&scoped=true"
import script from "./PlumbingSetup.vue?vue&type=script&lang=js"
export * from "./PlumbingSetup.vue?vue&type=script&lang=js"

import "./PlumbingSetup.vue?vue&type=style&index=0&id=cfa03dee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa03dee"]])

export default __exports__